<template>
  <el-drawer
    size="50%"
    :append-to-body="true"
    :visible.sync="drawerVisible"
    custom-class="device-drawer"
    direction="rtl"
  >
    <span slot="title" style="font-size: 18px">{{ $t('设备监控') }}</span>
    <DeviceAll class="device-height" />
  </el-drawer>
</template>

<script>
export default {
  name: 'DeviceDrawer',
  components: {
    DeviceAll: () => import('@/views/realdata/components/device-all')
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    drawerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  }
};
</script>

<style lang="scss">
.device-drawer {
  .el-drawer__body {
    height: calc(100% - 100px) !important;
  }
}
</style>
